var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiaaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 41,
    viewBox: "0 0 160 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0029 3.95115V10.1984H61.0869V40.1995H68.0895V10.1984H79.1735V3.95115H50.0071H50.0029ZM82.149 3.95115V40.1995H89.1558V3.95115H82.149ZM108.327 16.333L112.033 25.3596H104.597L108.327 16.333ZM106.863 3.46706L91.4176 40.2036H98.4661L102.151 31.2855H114.433L118.159 40.2036H125.371L109.926 3.46289H106.863V3.46706ZM142.272 16.333L145.978 25.3596H138.541L142.272 16.333ZM140.807 3.46706L125.362 40.2036H132.407L136.092 31.2855H148.373L152.1 40.2036H159.311L143.87 3.46289H140.807V3.46706Z",
    fill: "#041459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 0.199219H30.001V10.1982H39.9999V0.199219Z",
    fill: "#041459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9938 0.199219C14.4727 0.199219 9.99902 4.67705 9.99902 10.1982H30.0011V0.199219H19.9938Z",
    fill: "#305AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 20.2046C39.9999 25.7257 35.5221 30.1994 30.001 30.1994V20.2046V10.1973H39.9999V20.2046Z",
    fill: "#00AD97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 30.2004H29.5921H20.0063H9.99895V10.1983C9.99895 7.43563 11.1174 4.9359 12.9244 3.12891L2.92958 13.1237C1.11841 14.9349 0 17.4346 0 20.1931V40.1993H20.0063C22.7689 40.1993 25.2686 39.0809 27.0756 37.2656L37.0704 27.2708C35.2593 29.0778 32.7595 30.1962 30.001 30.1962V30.2004Z",
    fill: "#041459"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiaaLogo);
export default ForwardRef;